import Image from "next/image"

import { cn } from "@/lib/utils"

export default function Avatar({
  src,
  alt,
  size = "sm",
  className,
}: {
  src?: string
  alt?: string
  size?: "sm" | "md" | "lg" | "xs"
  className?: string
}) {
  function getSize() {
    switch (size) {
      case "xs":
        return "h-12 w-12"
      case "sm":
        return "h-16 w-16"
      case "md":
        return "h-32 w-32"
      case "lg":
        return "h-48 w-48"
    }
  }
  return (
    <>
      {src && alt ? (
        <div className={cn("shrink-0", className)}>
          <Image
            src={src}
            width={400}
            height={400}
            alt={alt}
            className={cn(
              "rounded-[20px] bg-white shrink-0 border border-neutral-200 object-contain object-center",
              getSize(),
            )}
          />
        </div>
      ) : (
        <div
          className={cn(
            "rounded-[20px] shrink-0 border border-neutral-200 bg-gradient-to-tr from-red-500 to-amber-500",
            getSize(),
            className
          )}
        ></div>
      )}
    </>
  )
}
